export default __webpack_public_path__ + "static/media/header-banner.ae694f01.png";